const defaultState = {
    count: 0,
    users: []
};

export default function customer(state = defaultState, action) {
    switch (action.type) {
        case "USERS":
            return {
                ...state,
                customers: action.value
            };
        case "USERS_COUNT":
            return {
                ...state,
                count: action.value
            };
        default:
            return state;
    }
}
